import React, { useState } from "react";
import ItemsSelectorPopup from "../../../default/popup/itemsSelectorPopup";

const MockupForm = () => {
    const [openConnectionModal, connectionSet] = useState(false);
    const handleSelectCardModal = () => {
        connectionSet(true);
    }; 
    return (
        <div className="settings-list-wrapper">
            <div className="single-settings">
                <label className="setting-title">Mockup title</label>
                <div className="setting-content">
                    <div className="sng-content-repeater">
                        <div className="sng-content">
                            <h5>Mockup title</h5>
                            <input className="sett-form-input" name="mockupTitle" placeholder="e.g. Mockup title" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="single-settings">
                <label className="setting-title">Select card</label>
                <div className="setting-content">
                    <div className="sng-content-repeater">
                        <div className="sng-content">
                            <div className="settings-list-wrapper">
                                <div className="single-settings grid-auto">
                                    <div className="setting-content">
                                        <div className="sng-content-repeater bs-wgt-wrapper">
                                            <div className="sng-content-widget">
                                                <div className="sng-wgt-left">
                                                    <i className="ri-phone-line"></i>
                                                    <span>Jeffery Peebles</span>
                                                </div>
                                               <div className="buttons-wrapper">
                                                    <a className="view-card-icon"><i className="ri-eye-line"></i></a>
                                                    <a className="delete-widget"><i className="ri-delete-bin-line"></i></a>
                                               </div>
                                            </div>
                                            <div className="add-bg-widget">
                                                <a onClick={handleSelectCardModal}> <i className="ri-add-circle-line"></i> Add new Card</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <ItemsSelectorPopup openModal={openConnectionModal} setOpen={connectionSet}/>
                        </div>
                    </div>
                </div>
            </div>
            <div className="single-settings">
                <label className="setting-title">Basic Information</label>
                <div className="setting-content">
                    <div className="sng-content-repeater">
                        <div className="sng-content">
                            <h5>Name <i className="ri-information-2-line"></i></h5>
                        </div>
                        <div className="sng-toggle-button">
                            <div className="pricing-switch">
                                <label className="switch">
                                    <input id="pricing-switch" type="checkbox" defaultChecked="checked"/>
                                    <span className="slider round"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="sng-content-repeater">
                        <div className="sng-content">
                            <h5>Company <i className="ri-information-2-line"></i></h5>
                        </div>
                        <div className="sng-toggle-button">
                            <div className="pricing-switch">
                                <label className="switch">
                                    <input id="pricing-switch" type="checkbox" />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="sng-content-repeater">
                        <div className="sng-content">
                            <h5>Title/ Role <i className="ri-information-2-line"></i></h5>
                        </div>
                        <div className="sng-toggle-button">
                            <div className="pricing-switch">
                                <label className="switch">
                                    <input id="pricing-switch" type="checkbox" />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="sng-content-repeater">
                        <div className="sng-content">
                            <h5>Address <i className="ri-information-2-line"></i></h5>
                        </div>
                        <div className="sng-toggle-button">
                            <div className="pricing-switch">
                                <label className="switch">
                                    <input id="pricing-switch" type="checkbox" />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="single-settings">
                <label className="setting-title">Cover and profile photo</label>
                <div className="setting-content">
                    <div className="sng-content-repeater">
                        <div className="sng-content">
                            <h5>Cover photo <i className="ri-information-2-line"></i></h5>
                        </div>
                        <div className="sng-toggle-button">
                            <div className="pricing-switch">
                                <label className="switch">
                                    <input id="pricing-switch" type="checkbox" />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="sng-content-repeater">
                        <div className="sng-content">
                            <h5>Profile photo <i className="ri-information-2-line"></i></h5>
                        </div>
                        <div className="sng-toggle-button">
                            <div className="pricing-switch">
                                <label className="switch">
                                    <input id="pricing-switch" type="checkbox" />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="single-settings">
                <label className="setting-title">Widget</label>
                <div className="setting-content">
                    <div className="sng-content-repeater">
                        <div className="sng-content">
                            <h5>Add new widgets <i className="ri-information-2-line"></i></h5>
                        </div>
                        <div className="sng-toggle-button">
                            <div className="pricing-switch">
                                <label className="switch">
                                    <input id="pricing-switch" type="checkbox" defaultChecked="checked" />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="single-settings">
                <label className="setting-title">Contact information</label>
                <div className="setting-content">
                    <div className="sng-content-repeater">
                        <div className="sng-content">
                            <h5>Phone number <i className="ri-information-2-line"></i></h5>
                        </div>
                        <div className="sng-toggle-button">
                            <div className="pricing-switch">
                                <label className="switch">
                                    <input id="pricing-switch" type="checkbox" defaultChecked="checked" />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="sng-content-repeater">
                        <div className="sng-content">
                            <h5>Text number <i className="ri-information-2-line"></i></h5>
                        </div>
                        <div className="sng-toggle-button">
                            <div className="pricing-switch">
                                <label className="switch">
                                    <input id="pricing-switch" type="checkbox" defaultChecked="checked" />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="sng-content-repeater">
                        <div className="sng-content">
                            <h5>Email <i className="ri-information-2-line"></i></h5>
                        </div>
                        <div className="sng-toggle-button">
                            <div className="pricing-switch">
                                <label className="switch">
                                    <input id="pricing-switch" type="checkbox" defaultChecked="checked" />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="sng-content-repeater">
                        <div className="sng-content">
                            <h5>Website <i className="ri-information-2-line"></i></h5>
                        </div>
                        <div className="sng-toggle-button">
                            <div className="pricing-switch">
                                <label className="switch">
                                    <input id="pricing-switch" type="checkbox" defaultChecked="checked" />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="sng-content-repeater">
                        <div className="sng-content">
                            <h5>Skype <i className="ri-information-2-line"></i></h5>
                        </div>
                        <div className="sng-toggle-button">
                            <div className="pricing-switch">
                                <label className="switch">
                                    <input id="pricing-switch" type="checkbox" defaultChecked="checked" />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="sng-content-repeater">
                        <div className="sng-content">
                            <h5>Social media link <i className="ri-information-2-line"></i></h5>
                        </div>
                        <div className="sng-toggle-button">
                            <div className="pricing-switch">
                                <label className="switch">
                                    <input id="pricing-switch" type="checkbox" defaultChecked="checked" />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="button-wrapper">
                <button className="btn cancel-btn">Cancel</button>
                <button className="btn submit-btn bg-primary">Save updates</button>
            </div>
        </div>
    );
}

export default MockupForm;
